import {CommonModule} from '@angular/common';
import {Component, EventEmitter, Input, input, InputSignal, OnInit, Output, signal, WritableSignal} from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import {AssertionUtils, TabsAndActionsHeaderComponent, TabsMenuItem, TranslationModule} from '@vdw/angular-component-library';

@Component({
  selector: 'app-custom-settings-dialog-header',
  templateUrl: './custom-settings-dialog-header.component.html',
  styleUrl: './custom-settings-dialog-header.component.scss',
  standalone: true,
  imports: [TabsAndActionsHeaderComponent, TranslationModule, CommonModule, MatButtonModule]
})
export class CustomSettingsDialogHeaderComponent implements OnInit {
  public menuItems: InputSignal<TabsMenuItem[]> = input.required();
  public entityTranslationKey: InputSignal<string> = input<string>();

  @Input() public canShowSave = true;
  @Output() public cancel: EventEmitter<void> = new EventEmitter();
  @Output() public save: EventEmitter<void> = new EventEmitter();

  protected selectedMenuTab: WritableSignal<TabsMenuItem> = signal(null);

  public ngOnInit(): void {
    if (!AssertionUtils.isEmpty(this.menuItems())) {
      this.updateSelectedTab(this.menuItems()[0]);
    }
  }

  protected updateSelectedTab(newSelectedTab: TabsMenuItem): void {
    this.selectedMenuTab.update(() => newSelectedTab);
  }
}
